import React from 'react';
import { css } from 'emotion';

const banner = css`
	display: flex;
	flex-direction: column;
	position: sticky;
	overflow-y: scroll;
	top: 70px;
	height: calc(100vh - 70px);
	img {
		width: 100%;
		margin-bottom: 10px;
	}
	@media (max-width: 576px) {
		flex-direction: row;
		overflow-x: scroll;
		position: inherit;
		width: 100%;
		height: 200px;
		padding: 10px;
		img {
			max-height: 100%;
			margin-bottom: 0;
		}
		img:not(:last-child) {
			margin-right: 10px;
		}
	}
`;

// BannerImages.Banner is wrapper component which is used to wrap the side images.
// Check usage in Home.js

class BannerImages extends React.Component {
	static Left = props => {
		const count = React.Children.count(props.children);

		return count ? <div className={banner}>{props.children}</div> : null;
	};

	static Right = props => {
		const count = React.Children.count(props.children);

		return count ? <div className={banner}>{props.children}</div> : null;
	};

	render() {
		const { children } = this.props;
		return children;
	}
}

export default BannerImages;
